import { SearchFilterModel } from "./models/search-filter.model";
import { NewsFilterComponent } from "./news-filter.component";

export class NewsFilterService {
    private _resultsLocation: string = "#listing";

    private _currentContext: JQuery = $();

    private _filter: NewsFilterComponent = null;

    private handleFilterSubmit(filter: SearchFilterModel): void {
        const locationSegments = [location.protocol, "//", location.host, location.pathname];
        const keys = Object.keys(filter);
        if (keys.length) {
            let queryString = "?";
            keys.forEach(key => {
                const value = Array.isArray(filter[key]) ? (filter[key] as Array<string>).join(",") : filter[key] as string;
                queryString = `${queryString}&${key}=${encodeURIComponent(value)}`;
            });
            locationSegments.push(queryString);
        }
        locationSegments.push(this._resultsLocation);

        const targetUrl = locationSegments.join("");

        if (location.href === targetUrl) {
            location.reload();
        } else {
            location.href = targetUrl;
        }
    }

    private bindEvents(): void {
        this._filter.on("submit")
            .subscribe((data: SearchFilterModel) => this.handleFilterSubmit(data));
    }

    private parseContext(): void {
        const filter = $(NewsFilterComponent.SELECTOR, this._currentContext);
        this._filter = new NewsFilterComponent();
        this._filter.init(filter);
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
    }
}
